import ExamMasterList from "../components/ExamMasterList";

export default function MasterRadiology() {
    return (
        <ExamMasterList
            kind="radiology"
            title="Master Radiologi"
            subtitle="Kelola daftar pemeriksaan radiologi & penunjang beserta unit cost dan harga jual."
            testidPrefix="rad"
        />
    );
}
